// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".manual .title[data-v-b8261638] {\n  text-indent: 0em;\n}\n.manual .formula[data-v-b8261638] {\n  color: #8f8f9d;\n  margin: 0;\n}\n.manual p[data-v-b8261638] {\n  text-indent: 2em;\n  line-height: 18px;\n}\n.manual .p3[data-v-b8261638] {\n  text-indent: 4em;\n}", ""]);
// Exports
module.exports = exports;
